// CarteraTab.js
// Pestana de CARTERA del dashboard ejecutivo: por cobrar y por pagar.
//
// Vive en frontend/src/components/executive/CarteraTab.js
//
// ===================================================================
// LO QUE MAS IMPORTA DE ESTA PANTALLA, y no es un numero.
// ===================================================================
//
// 1. LOS AVISOS. El servicio los genera a proposito, para evitar una conclusion
//    equivocada que ya se tuvo en esta empresa: la cartera salia 100% vencida y
//    cero por vencer, lo cual parece que todos los clientes pagan tarde. La
//    causa real es que muchos documentos NO traen condicion de pago, y cuando
//    falta, Odoo les pone vencimiento igual a la fecha de factura: nacen
//    vencidos. Eso es facturacion sin terminos, no morosidad. Medido el
//    31-oct-2026: de 18 facturas de la cubeta de 1 a 30 dias, 17 traen la misma
//    fecha de factura y de vencimiento.
//
// 2. QUE EL TOTAL INCLUYE EL INTERCOMPANIA. Los saldos de AMSCO Steel y de
//    Quality Metals son traspasos entre las empresas del mismo dueno, no
//    cobranza. Y SI estan dentro del numero grande, dentro de las nueve
//    cubetas, dentro de los porcentajes y dentro del vencido a mas de 90 dias.
//    La pantalla lo dice en un renglon visible debajo del total, no en un
//    tooltip. Una version anterior decia lo contrario sin querer y por eso se
//    corrigio.
//
// 3. LA FECHA. La cartera es SIEMPRE al dia de hoy: Odoo calcula el saldo
//    pendiente al momento de la consulta, asi que no se puede pedir a una fecha
//    pasada. El selector de fechas de la pantalla NO aplica aqui.
//
// 4. LAS NOTAS DE CREDITO van aparte y NO se envejecen: nadie debe una nota de
//    credito a 180 dias. Tampoco entran al total ni a los porcentajes.
//
// ===================================================================
// DEFECTOS QUE DOS REVISIONES ENCONTRARON EL 31-OCT-2026, Y QUE AQUI
// ESTAN ARREGLADOS. Un contralor leyo la pantalla como reporte y un
// ingeniero de React la reviso contra la forma real de la API.
// ===================================================================
//
// DE NOMBRES DE CAMPO, el peor tipo porque no truena, solo calla:
//   1. `billing_pace.last_invoice_date` NO existe: es `last_invoice`. La
//      tarjeta de la ultima factura salia con guion, justo en la caja que
//      existe para defender que la cartera no esta morosa.
//   2. `billing_pace.invoices_last_30` NO existe: es `invoices_last_30_days`.
//      Peor que el anterior: la guarda era `!== undefined`, asi que el dato NO
//      SE DIBUJABA y no salia ni un guion que delatara el problema.
//   3. `by_class` y `by_class_lines` venian en la respuesta y no se pintaban.
//      Son el dato que contesta "cuanto de esto no es cobranza de verdad".
//   4. `fake_aging` ({count, of}) venia y no se leia. Es la bandera de los
//      documentos que nacen vencidos.
//   5. `unapplied_direct` se leia nada mas para decidir si pintar un parrafo, y
//      nunca se imprimia el numero.
//   6. `partners_credit` no se pintaba nunca, asi que un cliente con puro
//      anticipo sin aplicar era invisible y las etiquetas NC no podian sumar el
//      total de notas de credito.
//
// DE TEXTO QUE INDUCE AL ERROR:
//   7. La caja de afiliadas decia "conviene verlo neto en lugar de sumarlo a la
//      cartera de clientes", que se lee como "esto no esta sumado arriba". SI
//      esta sumado arriba. Era lo contrario de la verdad.
//   8. El encabezado de los avisos decia "Lee esto antes de concluir algo", que
//      se lee como leyenda legal y se brinca. Ahora nombra la conclusion que
//      esta bloqueando.
//   9. En la caja de afiliadas los dias salian como "240d" sin etiqueta, y son
//      el documento MAS VIEJO, mientras la tabla por socio dice "Dias prom."
//      (ponderados). Dos cosas distintas con el mismo nombre en la misma
//      pantalla, y la no explicada era la de AMSCO.
//  10. La columna Dias imprimia un numero cuando el documento nacio vencido,
//      con la advertencia solo al pasar el raton. Alguien iba a llamar a cobrar
//      una factura "de 212 dias" que nunca tuvo plazo. Donde el numero no es
//      real ya no hay numero.
//  11. El encabezado del porcentaje era solo `%`, sin decir la base.
//  12. La tabla de cubetas no traia renglon de total, asi que no se podia
//      comprobar que las nueve suman.
//  13. En el detalle, AMSCO salia sin etiqueta, igual que un cliente, aunque el
//      servicio manda `cls` en cada renglon.
//  14. El pie que reconcilia la tabla por socio desaparecia al dar "Ver todos",
//      dejando ochenta renglones sin total.
//
// DE CORRECCION:
//  15. `abrirCubeta` no tenia token de peticion: dos clics seguidos y la lenta
//      pisaba a la rapida, mostrando la cubeta equivocada CON EL TITULO DE LA
//      QUE SI SE PIDIO. Ahora hay un contador en useRef.
//  16. Cerrar el detalle mientras cargaba lo VOLVIA A ABRIR SOLO al llegar la
//      respuesta. El mismo token lo arregla.
//  17. Al recargar desaparecia toda la pantalla, porque el return temprano no
//      distinguia "cargando por primera vez" de "recargando". Y por eso el
//      texto "Recargando..." nunca alcanzaba a verse.
//  18. Una respuesta 200 con cuerpo vacio dejaba la pestana en blanco, sin
//      mensaje y sin boton. Ahora se trata como error.
//  19. Si faltaba un lado entero, desaparecia sin avisar, al contrario de la
//      regla de que las nueve cubetas se muestran aun en cero.
//  20. Sin respuesta del servidor, el mensaje de respaldo era la MISMA frase
//      que el titulo del error, y nada decia que fue la red.
//  21. El boton de reintentar salia tambien en el 500, que el backend dice
//      explicitamente que no se arregla reintentando.
//  22. El panel de detalle se pintaba al final, a dos pantallas de scroll de la
//      cubeta en la que se hizo clic. Ahora va justo despues de los dos lados.
//  23. Las cubetas no se podian abrir con teclado.
//  24. El punto junto al monto de factura aparecia en casi todas las filas y
//      dejaba de distinguir "ya tiene pagos" de "esta partida en vencimientos".
//
// DE USO, para quien va a llamar a cobrar el lunes:
//  25. No se podia entrar a un SOCIO, aunque el endpoint ya acepta `partner_id`.
//      Era justo lo que hacia falta. Ahora el renglon del socio abre sus
//      documentos.
//  26. Saldo era la ultima de once columnas detras de una barra horizontal de
//      1,100 pixeles: en una laptop nacia fuera de pantalla. Ahora va al
//      principio.
//  27. Falta el documento mas viejo por socio, que es el dato de cobranza.
//  28. El vencido a mas de 90 dias no decia desde cuando se cuenta ni que
//      incluye intercompania, asi que no se podia copiar a un reporte de banco.

import { useState, useEffect, useCallback, useRef } from 'react';
import { executiveAPI } from '../../services/api';

// Formato local a proposito, en lugar de depender de fmt: asi este componente
// no se rompe si cambia la firma de alguna utilidad compartida.
const dinero = (n) => {
  if (n === null || n === undefined || !Number.isFinite(Number(n))) return '—';
  const v = Number(n);
  return (v < 0 ? '-$' : '$') + Math.abs(v).toLocaleString('en-US',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
const miles = (n) => (Number.isFinite(Number(n)) ? Number(n).toLocaleString('en-US') : '—');
const porciento = (n) => (Number.isFinite(Number(n)) ? Number(n).toFixed(1) + '%' : '—');
const fecha = (s) => (s ? String(s).slice(0, 10) : '—');
const r2 = (n) => Math.round(Number(n || 0) * 100) / 100;

// El estado de pago de Odoo, en palabras. Un valor que no conocemos se muestra
// tal cual: un estado nuevo de Odoo es un dato, no un hueco.
const PAGOS = {
  not_paid: 'sin pagar',
  in_payment: 'pago en tránsito',
  paid: 'pagada',
  partial: 'pago parcial',
  reversed: 'revertida',
  blocked: 'bloqueada',
  invoicing_legacy: 'heredada',
};
const PAGO = (s) => (s ? (PAGOS[s] || s) : '—');

// La clasificacion del socio. `inter` y `propio` NO son venta: son traspasos
// entre las empresas del dueno. Se marcan en pantalla para que nadie los
// trabaje como cobranza de cliente.
const CLASES = {
  inter: { etiqueta: 'intercompañía', ayuda: 'Otra empresa del grupo. No es venta: es traspaso.' },
  propio: { etiqueta: 'parte relacionada', ayuda: 'Parte relacionada del dueño. No es venta.' },
  desconocido: { etiqueta: 'sin clasificar', ayuda: 'El servicio no pudo clasificar a este socio.' },
};
const esTraspaso = (cls) => cls === 'inter' || cls === 'propio';

const CAJA = {
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius)',
  padding: 16,
  background: 'var(--bg-1)',
};
const TH = {
  textAlign: 'left', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.04em',
  color: 'var(--text-3)', padding: '6px 8px', borderBottom: '1px solid var(--border)',
  fontWeight: 600,
};
const TD = { padding: '6px 8px', fontSize: 13, borderBottom: '1px solid var(--border)' };
const NUM = { ...TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums' };
const TOTAL = { ...TD, borderTop: '2px solid var(--border)', borderBottom: 'none', fontWeight: 700 };
const TOTALNUM = { ...TOTAL, textAlign: 'right', fontVariantNumeric: 'tabular-nums' };

// Etiqueta chica para marcar lo que no es venta
function Marca({ cls }) {
  const c = CLASES[cls];
  if (!c) return null;
  return (
    <span title={c.ayuda}
          style={{ fontSize: 10, color: 'var(--text-3)', border: '1px solid var(--border)',
                   borderRadius: 3, padding: '1px 4px', marginLeft: 6, whiteSpace: 'nowrap' }}>
      {c.etiqueta}
    </span>
  );
}

function Dato({ chico, grande, alerta, ayuda }) {
  return (
    <div title={ayuda}>
      <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.04em',
                    color: 'var(--text-3)', marginBottom: 2 }}>{chico}</div>
      <div style={{ fontSize: 18, fontWeight: 700, fontVariantNumeric: 'tabular-nums',
                    color: alerta ? 'var(--red)' : 'var(--text)' }}>{grande}</div>
    </div>
  );
}

export default function CarteraTab() {
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [errorCodigo, setErrorCodigo] = useState(null);
  const [drill, setDrill] = useState(null);
  const [drillCargando, setDrillCargando] = useState(false);
  const [recargando, setRecargando] = useState(false);
  const [todosSocios, setTodosSocios] = useState(false);

  // Token de peticion. Sin esto, dos clics seguidos en cubetas distintas dejan
  // que la respuesta lenta pise a la rapida, y la pantalla muestra una cubeta
  // con el titulo de otra. Tambien evita que una respuesta en vuelo reabra el
  // panel que el usuario ya cerro.
  const petRef = useRef(0);
  const panelRef = useRef(null);

  const cargar = useCallback(async () => {
    setCargando(true); setError(''); setErrorCodigo(null);
    petRef.current++; setDrill(null);
    try {
      const { data: d } = await executiveAPI.cartera();
      if (!d || typeof d !== 'object') {
        // 200 con cuerpo vacio. Antes esto dejaba la pestana en blanco, sin
        // mensaje y sin salida mas que recargar la pagina.
        setError('La respuesta de la cartera vino vacía. No hay nada que mostrar.');
        setData(null);
      } else {
        setData(d);
      }
    } catch (e) {
      const r = e && e.response;
      setErrorCodigo(r ? r.status : null);
      setError((r && r.data && r.data.error) ||
        // Sin `response` es fallo de red. Antes el texto de respaldo era la
        // misma frase que el titulo del error y nada decia que fue la red.
        'No hubo respuesta del servidor. Revisa la conexión y vuelve a intentar.');
      setData(null);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const recargar = async () => {
    setRecargando(true);
    try { await executiveAPI.carteraRefresh(); } catch (e) { /* si falla tirar el cache, igual recargamos */ }
    await cargar();
    setRecargando(false);
  };

  // Un solo camino para abrir el detalle, por cubeta o por socio. El endpoint
  // acepta los dos y antes la pantalla solo usaba el de cubeta.
  const abrir = async (titulo, cuerpo, marca) => {
    const mia = ++petRef.current;
    setDrillCargando(true);
    setDrill({ titulo, ...marca, rows: null });
    setTimeout(() => {
      if (panelRef.current && panelRef.current.scrollIntoView) {
        panelRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 0);
    try {
      const { data: d } = await executiveAPI.carteraDrilldown(cuerpo);
      if (petRef.current !== mia) return;        // llego tarde: ya se pidio otra cosa
      setDrill({ titulo, ...marca, ...d });
    } catch (e) {
      if (petRef.current !== mia) return;
      setDrill({
        titulo, ...marca, rows: [],
        error: (e && e.response && e.response.data && e.response.data.error) ||
          'No se pudo abrir el detalle.',
      });
    } finally {
      if (petRef.current === mia) setDrillCargando(false);
    }
  };

  const cerrarDrill = () => { petRef.current++; setDrill(null); setDrillCargando(false); };

  // Solo pantalla en blanco la PRIMERA vez. Al recargar se dejan los datos
  // viejos para que no desaparezca el tablero completo.
  if (cargando && !data) {
    return <p style={{ fontSize: 13, color: 'var(--text-3)' }}>Cargando la cartera desde Odoo…</p>;
  }

  if (error && !data) {
    return (
      <div style={{
        background: 'var(--red-bg)', border: '1px solid var(--red)',
        borderRadius: 'var(--radius)', padding: '12px 16px', fontSize: 13,
      }}>
        <strong>No se pudo cargar la cartera.</strong>
        <div style={{ marginTop: 6 }}>{error}</div>
        {/* El backend dice que un 500 NO se arregla reintentando, asi que no se
            invita a darle refresh para siempre. */}
        {errorCodigo !== 500 && (
          <button onClick={cargar} className="btn btn-sm" style={{ marginTop: 10 }}>
            Volver a intentar
          </button>
        )}
      </div>
    );
  }

  if (!data) return null;

  const LADOS = [
    { k: 'ar', titulo: 'Por cobrar', verbo: 'Quién nos debe', d: data.ar },
    { k: 'ap', titulo: 'Por pagar', verbo: 'A quién le debemos', d: data.ap },
  ];
  const lados = LADOS.filter((l) => l.d);
  const faltantes = LADOS.filter((l) => !l.d);

  // Cuanto del total NO es cobranza de verdad. Se calcula de `partners`, que
  // esta en la MISMA base que el total (solo cargos), en lugar de `by_class`,
  // que suma todos los renglones legibles incluyendo las notas de credito y por
  // tanto no cuadraria contra el numero grande.
  const traspasoDe = (lado) => {
    const ps = Array.isArray(lado.partners) ? lado.partners : [];
    const ts = ps.filter((p) => esTraspaso(p.cls));
    return {
      monto: r2(ts.reduce((s, p) => s + Number(p.amount || 0), 0)),
      socios: ts.length,
      nombres: ts.map((p) => p.name).filter(Boolean),
    };
  };

  return (
    <>
      {/* ----------- LA FECHA, Y QUE EL RANGO DE ARRIBA NO APLICA ----------- */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap', marginBottom: 16 }}>
        <div style={{ fontSize: 13, color: 'var(--text-2)', maxWidth: 720 }}>
          <strong>Al día de hoy, {fecha(data.as_of)}.</strong>{' '}
          El selector de fechas de arriba <strong>no aplica a esta pestaña</strong>: Odoo calcula
          el saldo pendiente al momento de la consulta, así que no se puede pedir la cartera a
          una fecha pasada. Para tener comparativo hay que guardar una foto mensual.
        </div>
        <button onClick={recargar} disabled={recargando} className="btn btn-sm"
                style={{ marginLeft: 'auto', whiteSpace: 'nowrap' }}>
          {recargando ? 'Recargando…' : 'Recargar desde Odoo'}
        </button>
      </div>

      {/* Si un lado entero no vino, se dice. Antes desaparecia sin avisar. */}
      {faltantes.length > 0 && (
        <div style={{ background: 'var(--red-bg)', border: '1px solid var(--red)',
                      borderRadius: 'var(--radius)', padding: '10px 14px', fontSize: 13,
                      marginBottom: 16 }}>
          <strong>Falta un lado completo:</strong>{' '}
          {faltantes.map((l) => l.titulo.toLowerCase()).join(' y ')} no vino en la respuesta.
          Eso NO significa que esté en cero: significa que no se midió.
        </div>
      )}

      {/* Si hubo error pero hay datos viejos en pantalla, se avisa sin borrarlos */}
      {error && data && (
        <div style={{ background: 'var(--red-bg)', border: '1px solid var(--red)',
                      borderRadius: 'var(--radius)', padding: '10px 14px', fontSize: 13,
                      marginBottom: 16 }}>
          <strong>La última recarga falló.</strong> Lo de abajo es de la consulta anterior.
          <div style={{ marginTop: 4 }}>{error}</div>
        </div>
      )}

      {/* ----------- LOS AVISOS. ARRIBA Y NOMBRANDO LA CONCLUSION ----------- */}
      {Array.isArray(data.avisos) && data.avisos.length > 0 && (
        <div style={{
          background: 'var(--yellow-bg, #fff8e1)', border: '1px solid var(--yellow, #e0a800)',
          borderRadius: 'var(--radius)', padding: '12px 16px', marginBottom: 18,
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>
            Esta cartera no se puede leer como morosidad sin antes mirar{' '}
            {data.avisos.length === 1 ? 'esta razón' : 'estas ' + data.avisos.length + ' razones'}:
          </div>
          <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, lineHeight: 1.55 }}>
            {data.avisos.map((a, i) => <li key={i} style={{ marginBottom: 4 }}>{a}</li>)}
          </ul>
        </div>
      )}

      {/* ----------- EL RITMO DE FACTURACION ----------- */}
      {data.billing_pace && (
        <div style={{ ...CAJA, marginBottom: 18, display: 'flex', gap: 28, flexWrap: 'wrap' }}>
          {/* Los nombres son last_invoice e invoices_last_30_days. La version
              anterior leia last_invoice_date e invoices_last_30: el primero
              salia con guion y el segundo NO SE DIBUJABA. */}
          <Dato chico="Última factura publicada"
                grande={fecha(data.billing_pace.last_invoice)}
                ayuda={data.billing_pace.last_invoice_name
                  ? 'Documento: ' + data.billing_pace.last_invoice_name : undefined} />
          <Dato chico="Días desde la última"
                grande={data.billing_pace.days_since_last_invoice === null ||
                        data.billing_pace.days_since_last_invoice === undefined
                  ? '—' : miles(data.billing_pace.days_since_last_invoice)}
                alerta={Number(data.billing_pace.days_since_last_invoice) > 15} />
          <Dato chico="Facturas en 30 días"
                grande={data.billing_pace.invoices_last_30_days === null ||
                        data.billing_pace.invoices_last_30_days === undefined
                  ? '—' : miles(data.billing_pace.invoices_last_30_days)} />
          <div style={{ fontSize: 12, color: 'var(--text-3)', maxWidth: 420, alignSelf: 'center' }}>
            Si pasaron muchos días desde la última factura, una cartera que se ve vencida
            puede ser facturación tardía y no morosidad.
          </div>
        </div>
      )}

      {/* ----------- LOS DOS LADOS ----------- */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(440px, 1fr))', gap: 18 }}>
        {lados.map((l) => {
          const tr = traspasoDe(l.d);
          const terceros = r2(Number(l.d.total || 0) - tr.monto);
          const sumaCubetas = r2((l.d.buckets || []).reduce((s, b) => s + Number(b.amount || 0), 0));
          const fa = l.d.fake_aging;
          return (
            <div key={l.k} style={CAJA}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 6 }}>
                <h3 style={{ margin: 0, fontSize: 15 }}>{l.titulo}</h3>
                <span style={{ fontSize: 20, fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
                  {dinero(l.d.total)}
                </span>
                <span style={{ fontSize: 12, color: 'var(--text-3)', marginLeft: 'auto' }}>
                  {miles(l.d.lines)} renglones
                </span>
              </div>

              {/* EL RENGLON QUE FALTABA, y es el mas importante de la caja: que
                  parte del numero grande NO es cobranza de verdad. Visible, no
                  en tooltip. */}
              {tr.monto > 0 ? (
                <div style={{ fontSize: 12, color: 'var(--text-2)', marginBottom: 12,
                              borderLeft: '3px solid var(--yellow, #e0a800)', paddingLeft: 8 }}>
                  <strong>Este total YA incluye {dinero(tr.monto)}</strong> de intercompañía y
                  partes relacionadas{tr.nombres.length ? ' (' + tr.nombres.slice(0, 3).join(', ')
                    + (tr.nombres.length > 3 ? ' y ' + (tr.nombres.length - 3) + ' más' : '') + ')' : ''},
                  que son traspasos entre las empresas del grupo y no venta.{' '}
                  <strong>De terceros: {dinero(terceros)}.</strong> El intercompañía también está
                  dentro de las cubetas, de los porcentajes y del vencido a más de 90 días.
                </div>
              ) : (
                <div style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 12 }}>
                  No hay intercompañía ni partes relacionadas en este total: es todo de terceros.
                </div>
              )}

              {/* Vencido a mas de 90 dias: el subtotal que piden los contratos
                  de credito. Antes no decia desde cuando se cuenta ni que
                  incluye intercompania, asi que no se podia copiar a un
                  reporte de banco. */}
              {l.d.overdue_90 && (
                <div style={{
                  background: Number(l.d.overdue_90.amount) > 0 ? 'var(--red-bg)' : 'var(--bg-2)',
                  border: '1px solid ' + (Number(l.d.overdue_90.amount) > 0 ? 'var(--red)' : 'var(--border)'),
                  borderRadius: 'var(--radius)', padding: '8px 12px', marginBottom: 14, fontSize: 13,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                    <strong>Vencido a más de 90 días</strong>
                    <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
                      {dinero(l.d.overdue_90.amount)}
                    </span>
                    <span style={{ color: 'var(--text-3)' }}>
                      {miles(l.d.overdue_90.docs)} docs · {porciento(l.d.overdue_90.pct)} del total
                    </span>
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 4 }}>
                    Se cuenta desde la fecha de <strong>vencimiento</strong>, no desde la fecha de
                    factura. Es bruto: no resta notas de crédito
                    {tr.monto > 0 ? ' y puede incluir intercompañía' : ''}. Antes de mandarlo a un
                    banco hay que decir las dos cosas.
                  </div>
                </div>
              )}

              {/* Las nueve cubetas. Se devuelven TODAS, aunque esten en cero,
                  para poder distinguir "cero" de "no se midio". */}
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={TH}>Antigüedad</th>
                    <th style={{ ...TH, textAlign: 'right' }}>Docs</th>
                    <th style={{ ...TH, textAlign: 'right' }}>Monto</th>
                    <th style={{ ...TH, textAlign: 'right' }}
                        title="Porcentaje del total de cargos del lado. Las notas de crédito no entran ni al numerador ni al denominador, así que los nueve suman 100.">
                      % del total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(l.d.buckets || []).map((b) => {
                    const vacia = !b.docs;
                    const abierta = drill && drill.side === l.k && drill.bucket === b.key;
                    // Las cubetas vencidas pueden traer documentos que nacieron
                    // vencidos por falta de condicion de pago. Se marca.
                    const sospechosa = !vacia && fa && Number(fa.count) > 0 &&
                      b.key !== 'current' && b.key !== 'today';
                    return (
                      <tr key={b.key}
                          onClick={() => !vacia && abrir(
                            l.titulo + ' · ' + b.label, { side: l.k, bucket: b.key },
                            { side: l.k, bucket: b.key })}
                          onKeyDown={(e) => {
                            if (vacia) return;
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              abrir(l.titulo + ' · ' + b.label, { side: l.k, bucket: b.key },
                                { side: l.k, bucket: b.key });
                            }
                          }}
                          role={vacia ? undefined : 'button'}
                          tabIndex={vacia ? undefined : 0}
                          style={{ cursor: vacia ? 'default' : 'pointer',
                                   background: abierta ? 'var(--bg-2)' : 'transparent' }}>
                        <td style={{ ...TD, color: vacia ? 'var(--text-3)' : 'var(--text)' }}>
                          {b.label}
                          {!vacia && <span style={{ color: 'var(--text-3)', fontSize: 11 }}> ›</span>}
                          {sospechosa && (
                            <span style={{ color: 'var(--text-3)' }}
                                  title={fa.count + ' de ' + fa.of + ' documentos de este lado no traen condición de pago, así que Odoo les puso vencimiento igual a la fecha de factura. Parte de esta antigüedad no es real.'}> ⚠</span>
                          )}
                        </td>
                        <td style={{ ...NUM, color: vacia ? 'var(--text-3)' : 'var(--text-2)' }}>
                          {miles(b.docs)}
                        </td>
                        <td style={{ ...NUM, fontWeight: vacia ? 400 : 600,
                                     color: vacia ? 'var(--text-3)' : 'var(--text)' }}>
                          {dinero(b.amount)}
                        </td>
                        <td style={{ ...NUM, color: 'var(--text-3)' }}>{porciento(b.pct)}</td>
                      </tr>
                    );
                  })}
                  {/* El renglon de total, que faltaba. Sin el, el lector ve el
                      numero grande arriba y nueve montos abajo, y tiene que
                      creer que suman. */}
                  <tr>
                    <td style={TOTAL}>Total, base del porcentaje</td>
                    <td style={TOTALNUM}>{miles(l.d.lines)}</td>
                    <td style={TOTALNUM}>{dinero(sumaCubetas)}</td>
                    <td style={{ ...TOTALNUM, color: 'var(--text-3)' }}>100.0%</td>
                  </tr>
                  {Math.abs(sumaCubetas - Number(l.d.total || 0)) > 0.01 && (
                    <tr>
                      <td colSpan={4} style={{ ...TD, borderBottom: 'none', fontSize: 11,
                                               color: 'var(--red)' }}>
                        Las cubetas suman {dinero(sumaCubetas)} y el total de arriba dice{' '}
                        {dinero(l.d.total)}. Hay renglones que no cayeron en ninguna cubeta.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Las notas de credito, APARTE y sin envejecer */}
              {l.d.credits && (
                <div style={{ marginTop: 14, fontSize: 12, color: 'var(--text-2)',
                              borderTop: '1px dashed var(--border)', paddingTop: 10 }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'baseline', flexWrap: 'wrap' }}>
                    <strong>Notas de crédito y anticipos sin aplicar</strong>
                    <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
                      {dinero(l.d.credits.total)}
                    </span>
                    <span style={{ color: 'var(--text-3)' }}>{miles(l.d.credits.lines)} renglones</span>
                  </div>
                  <div style={{ color: 'var(--text-3)', marginTop: 4 }}>
                    No se envejecen y NO entran al total ni a los porcentajes de arriba. Nadie debe
                    una nota de crédito a 180 días.
                  </div>
                </div>
              )}

              {/* Lo que conviene saber del lado */}
              <div style={{ marginTop: 10, fontSize: 11, color: 'var(--text-3)', lineHeight: 1.6 }}>
                {Array.isArray(l.d.currencies) && l.d.currencies.length > 1 && (
                  <div>
                    <strong>Multimoneda:</strong>{' '}
                    {l.d.currencies.map((c) => c.code + ' (' + miles(c.lines) + ')').join(', ')}
                  </div>
                )}
                {Number(l.d.unreadable_lines) > 0 && (
                  <div>{miles(l.d.unreadable_lines)} renglones con fecha ilegible.</div>
                )}
                {Number(l.d.dust_lines) > 0 && (
                  <div>{miles(l.d.dust_lines)} renglones de polvo de redondeo, excluidos.</div>
                )}
                {l.d.unapplied_direct !== undefined && l.d.unapplied_direct !== null && (
                  <div>
                    Cuadre contra facturas: <strong>{dinero(l.d.unapplied_direct)}</strong>.
                    Debería ser cero; es una diferencia residual que absorbe recibos, polvo de
                    redondeo y multimoneda, y <strong>no</strong> es la cuenta de anticipos.
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* ----------- EL DETALLE. VA AQUI, pegado a las cubetas, no al final de
           la pantalla a dos scrolls de distancia. ----------- */}
      {drill && (
        <div ref={panelRef} style={{ ...CAJA, marginTop: 18 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 12,
                        flexWrap: 'wrap' }}>
            <h3 style={{ margin: 0, fontSize: 15 }}>{drill.titulo}</h3>
            {drill.total !== undefined && (
              <span style={{ fontSize: 16, fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
                {dinero(drill.total)}
              </span>
            )}
            {drill.matched !== undefined && (
              <span style={{ fontSize: 12, color: 'var(--text-3)' }}>
                {miles(drill.matched)} documento{Number(drill.matched) === 1 ? '' : 's'}
              </span>
            )}
            <button onClick={cerrarDrill} className="btn btn-sm btn-ghost"
                    style={{ marginLeft: 'auto' }}>Cerrar</button>
          </div>

          {drillCargando && (
            <p style={{ fontSize: 13, color: 'var(--text-3)' }}>Cargando el detalle…</p>
          )}

          {drill.error && (
            <div style={{ background: 'var(--red-bg)', border: '1px solid var(--red)',
                          borderRadius: 'var(--radius)', padding: '10px 14px', fontSize: 13 }}>
              {drill.error}
            </div>
          )}

          {/* El recorte se dice ANTES de la tabla, que es donde sirve. */}
          {drill.note && (
            <div style={{ fontSize: 12, color: 'var(--text-2)', marginBottom: 10 }}>
              <strong>Ojo:</strong> {drill.note} No sumes la tabla.
            </div>
          )}

          {Array.isArray(drill.avisos) && drill.avisos.length > 0 && (
            <ul style={{ margin: '0 0 10px', paddingLeft: 18, fontSize: 12, color: 'var(--text-2)' }}>
              {drill.avisos.map((a, i) => <li key={i}>{a}</li>)}
            </ul>
          )}

          {Array.isArray(drill.rows) && drill.rows.length > 0 && (
            <div style={{ overflowX: 'auto' }}>
              {/* SALDO y DIAS van al principio: son lo que se busca. Antes Saldo
                  era la ultima de once columnas detras de una barra de 1,100
                  pixeles y en una laptop nacia fuera de pantalla. */}
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 1020 }}>
                <thead>
                  <tr>
                    <th style={{ ...TH, textAlign: 'right' }}>Saldo</th>
                    <th style={{ ...TH, textAlign: 'right' }}>Días</th>
                    <th style={TH}>Socio</th>
                    <th style={TH}>Documento</th>
                    <th style={TH}>Orden</th>
                    <th style={TH}>Vendedor</th>
                    <th style={TH}>Factura</th>
                    <th style={TH}>Vence</th>
                    <th style={{ ...TH, textAlign: 'right' }}>Monto factura</th>
                    <th style={TH}>Pago</th>
                  </tr>
                </thead>
                <tbody>
                  {drill.rows.map((r) => (
                    <tr key={r.line_id}>
                      <td style={{ ...NUM, fontWeight: 600 }}>{dinero(r.amount)}</td>
                      <td style={NUM}>
                        {/* Donde el numero no es real, NO hay numero. Un
                            documento que nace vencido por falta de condicion de
                            pago no tiene 212 dias de atraso: no tuvo plazo. */}
                        {r.aging_fake ? (
                          <span title="Este documento no trae condición de pago, así que Odoo le puso vencimiento igual a la fecha de factura. No tuvo plazo, así que no tiene atraso real."
                                style={{ color: 'var(--text-3)', fontSize: 11 }}>
                            sin términos
                          </span>
                        ) : r.days_flag === 'sin_fecha' ? (
                          <span style={{ color: 'var(--text-3)', fontSize: 11 }}
                                title="Sin fecha de vencimiento">sin fecha</span>
                        ) : r.days_flag === 'fecha_ilegible' ? (
                          <span style={{ color: 'var(--red)', fontSize: 11 }}
                                title="La fecha de vencimiento no se pudo leer">ilegible</span>
                        ) : miles(r.days_overdue)}
                      </td>
                      <td style={TD}>
                        {r.partner}
                        {/* AMSCO salia sin etiqueta, igual que un cliente. */}
                        {esTraspaso(r.cls) && <Marca cls={r.cls} />}
                      </td>
                      <td style={TD}>
                        {r.document || '—'}
                        {r.type_label && r.move_type !== 'out_invoice' && r.move_type !== 'in_invoice' && (
                          <span style={{ fontSize: 11, color: 'var(--text-3)' }}> · {r.type_label}</span>
                        )}
                      </td>
                      <td style={TD}>
                        {r.sale_order || '—'}
                        {r.sale_order_multiple && (
                          <span title="Este documento referencia varias órdenes"
                                style={{ color: 'var(--text-3)' }}> ⚠</span>
                        )}
                      </td>
                      <td style={{ ...TD, color: 'var(--text-2)' }}>{r.salesperson || '—'}</td>
                      <td style={TD}>{fecha(r.invoice_date)}</td>
                      <td style={TD}>{fecha(r.due_date)}</td>
                      <td style={{ ...NUM, color: 'var(--text-2)' }}>
                        {r.invoice_total === null || r.invoice_total === undefined
                          ? '—' : dinero(r.invoice_total)}
                        {/* El punto solo cuando de verdad significa algo. Antes
                            salia en casi todas las filas, porque TODA factura
                            con condicion de pago cae en esa condicion. */}
                        {r.payment_state === 'partial' && (
                          <span title="Esta factura ya tiene pagos aplicados: el saldo es menor que su total."
                                style={{ color: 'var(--text-3)' }}> ·</span>
                        )}
                      </td>
                      <td style={{ ...TD, fontSize: 12 }}>{PAGO(r.payment_state)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <p style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 8, maxWidth: 860 }}>
                <strong>Saldo</strong> es lo que queda de este renglón. <strong>Monto factura</strong>{' '}
                es el total del documento completo: una factura con condición de pago aparece{' '}
                <strong>una vez por vencimiento</strong>, así que su total se repite en cada renglón y
                no se puede restar del saldo para sacar lo cobrado.{' '}
                <strong>Días</strong> dice "sin términos" cuando el documento nació vencido por no
                traer condición de pago: ahí no hay atraso real que cobrar.
              </p>
            </div>
          )}

          {Array.isArray(drill.rows) && drill.rows.length === 0 && !drill.error && !drillCargando && (
            <p style={{ fontSize: 13, color: 'var(--text-3)' }}>
              No trae documentos abiertos.
            </p>
          )}
        </div>
      )}

      {/* ----------- POR SOCIO: CON QUIEN SE TRABAJA LA COBRANZA -----------
          Sale de `partners`, que ya venia en la respuesta. El renglon ABRE los
          documentos del socio: el endpoint acepta partner_id y antes la
          pantalla nunca lo usaba, que era justo lo que hacia falta para
          trabajar la cobranza. */}
      {lados.some((l) => Array.isArray(l.d.partners) && l.d.partners.length) && (
        <div style={{ marginTop: 18 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 10,
                        flexWrap: 'wrap' }}>
            <h3 style={{ margin: 0, fontSize: 15 }}>Por socio</h3>
            <span style={{ fontSize: 12, color: 'var(--text-3)' }}>
              ordenado por saldo · haz clic en un renglón para ver sus documentos
            </span>
            <button onClick={() => setTodosSocios(!todosSocios)} className="btn btn-sm btn-ghost"
                    style={{ marginLeft: 'auto' }}>
              {todosSocios ? 'Ver solo los doce más grandes' : 'Ver todos'}
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(460px, 1fr))', gap: 18 }}>
            {lados.filter((l) => Array.isArray(l.d.partners) && l.d.partners.length).map((l) => {
              const lista = todosSocios ? l.d.partners : l.d.partners.slice(0, 12);
              const sumaMostrada = r2(lista.reduce((s, p) => s + Number(p.amount || 0), 0));
              const suma90 = r2(lista.reduce((s, p) => s + Number(p.over_90 || 0), 0));
              const credito = Array.isArray(l.d.partners_credit) ? l.d.partners_credit : [];
              return (
                <div key={l.k} style={CAJA}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginBottom: 10 }}>
                    <strong style={{ fontSize: 13 }}>{l.verbo}</strong>
                    <span style={{ fontSize: 12, color: 'var(--text-3)' }}>
                      {lista.length} de {l.d.partners.length} socios con saldo
                    </span>
                  </div>
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 440 }}>
                      <thead>
                        <tr>
                          <th style={TH}>Socio</th>
                          <th style={{ ...TH, textAlign: 'right' }}>Saldo</th>
                          <th style={{ ...TH, textAlign: 'right' }}>+90 días</th>
                          <th style={{ ...TH, textAlign: 'right' }}
                              title="Días promedio PONDERADOS por monto. El documento más viejo engaña: un socio con un renglón nuevo grande y uno viejo de quinientos pesos se vería a cuatrocientos días.">
                            Días prom.
                          </th>
                          <th style={{ ...TH, textAlign: 'right' }}
                              title="Días del documento MÁS VIEJO de este socio. Es el dato que se usa al llamar a cobrar.">
                            Más viejo
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {lista.map((p) => {
                          const abierto = drill && drill.side === l.k &&
                            drill.partner_id === p.partner_id;
                          const ir = () => abrir(
                            l.titulo + ' · ' + (p.name || '(sin socio)'),
                            p.partner_id ? { side: l.k, partner_id: p.partner_id }
                                         : { side: l.k, no_partner: true },
                            { side: l.k, partner_id: p.partner_id });
                          return (
                            <tr key={p.partner_id || p.name}
                                onClick={ir}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ir(); }
                                }}
                                role="button" tabIndex={0}
                                style={{ cursor: 'pointer',
                                         background: abierto ? 'var(--bg-2)' : 'transparent' }}>
                              <td style={TD}>
                                {p.name || '(sin socio)'}
                                <span style={{ color: 'var(--text-3)', fontSize: 11 }}> ›</span>
                                {esTraspaso(p.cls) && <Marca cls={p.cls} />}
                                {Number(p.credits) > 0 && (
                                  <span style={{ fontSize: 11, color: 'var(--text-3)' }}
                                        title="Tiene notas de crédito o anticipos sin aplicar. El saldo de la derecha NO los resta.">
                                    {' '}· NC {dinero(p.credits)}
                                  </span>
                                )}
                              </td>
                              <td style={{ ...NUM, fontWeight: 600 }}>{dinero(p.amount)}</td>
                              <td style={{ ...NUM,
                                           color: Number(p.over_90) > 0 ? 'var(--red)' : 'var(--text-3)' }}>
                                {Number(p.over_90) > 0 ? dinero(p.over_90) : '—'}
                              </td>
                              <td style={{ ...NUM, color: 'var(--text-2)' }}>
                                {p.avg_days === null || p.avg_days === undefined
                                  ? '—' : miles(p.avg_days)}
                                {p.oldest_unknown && (
                                  <span title="Alguno de sus documentos no trae fecha de vencimiento legible, así que no entra al promedio."
                                        style={{ color: 'var(--text-3)' }}> ⚠</span>
                                )}
                              </td>
                              <td style={{ ...NUM, color: 'var(--text-2)' }}>
                                {p.oldest_days === null || p.oldest_days === undefined
                                  ? '—' : miles(p.oldest_days)}
                              </td>
                            </tr>
                          );
                        })}
                        {/* El pie de reconciliacion va SIEMPRE, tambien al ver
                            todos. Antes desaparecia y dejaba ochenta renglones
                            sin total. */}
                        <tr>
                          <td style={TOTAL}>
                            {todosSocios ? 'Los ' + lista.length + ' socios' : 'Estos ' + lista.length}
                          </td>
                          <td style={TOTALNUM}>{dinero(sumaMostrada)}</td>
                          <td style={TOTALNUM}>{dinero(suma90)}</td>
                          <td style={TOTAL} />
                          <td style={TOTAL} />
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 8 }}>
                    {Math.abs(sumaMostrada - Number(l.d.total || 0)) <= 0.01
                      ? 'Suman ' + dinero(sumaMostrada) + ', que es el total de ' +
                        l.titulo.toLowerCase() + ' de arriba.'
                      : 'Suman ' + dinero(sumaMostrada) + ' de ' + dinero(l.d.total) + '. Los otros ' +
                        (l.d.partners.length - lista.length) + ' socios están en Ver todos.'}
                    {' '}La columna <strong>+90 días</strong> es solo de los socios mostrados: no
                    suma la caja de vencido de arriba.
                  </p>
                  {/* Los socios que SOLO traen notas de credito o anticipos. Sin
                      esto eran invisibles y las etiquetas NC no podian sumar el
                      total de notas de credito de arriba. */}
                  {credito.length > 0 && (
                    <div style={{ marginTop: 12, borderTop: '1px dashed var(--border)', paddingTop: 10 }}>
                      <div style={{ fontSize: 12, marginBottom: 6 }}>
                        <strong>{credito.length} socio{credito.length === 1 ? '' : 's'} con saldo a su
                        favor y sin cargos</strong>
                        <span style={{ color: 'var(--text-3)' }}>
                          {' '}· no aparecen arriba porque no deben nada
                        </span>
                      </div>
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <tbody>
                          {credito.slice(0, todosSocios ? credito.length : 6).map((p) => (
                            <tr key={'c' + (p.partner_id || p.name)}>
                              <td style={{ ...TD, fontSize: 12 }}>
                                {p.name || '(sin socio)'}
                                {esTraspaso(p.cls) && <Marca cls={p.cls} />}
                              </td>
                              <td style={{ ...NUM, fontSize: 12 }}>{dinero(p.credits)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {!todosSocios && credito.length > 6 && (
                        <p style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 6 }}>
                          y {credito.length - 6} más en Ver todos.
                        </p>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ----------- NETO POR AFILIADA ----------- */}
      {Array.isArray(data.affiliates) && data.affiliates.length > 0 && (
        <div style={{ ...CAJA, marginTop: 18 }}>
          <h3 style={{ margin: '0 0 4px', fontSize: 15 }}>Neto por afiliada</h3>
          {/* EL TEXTO QUE ESTABA AL REVES. La version anterior decia "conviene
              verlo neto en lugar de sumarlo a la cartera de clientes", que se
              lee como "esto no esta sumado arriba". SI esta sumado arriba. */}
          <p style={{ fontSize: 12, color: 'var(--text-2)', margin: '0 0 12px', maxWidth: 760 }}>
            <strong>Estas cifras YA están incluidas en los totales de por cobrar y por pagar de
            arriba.</strong> Aquí se ven netas porque son traspasos entre las empresas del grupo,
            no venta ni compra de verdad. Para saber cuánta cobranza de terceros hay, mira el
            renglón amarillo debajo de cada total.
          </p>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={TH}>Afiliada</th>
                <th style={{ ...TH, textAlign: 'right' }}>Nos deben</th>
                <th style={{ ...TH, textAlign: 'right' }}>Le debemos</th>
                <th style={{ ...TH, textAlign: 'right' }}
                    title="Positivo significa que la afiliada nos debe a nosotros.">
                  Neto · positivo = nos deben
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Los campos son receivable y payable. Una version anterior los
                  llamo ar y ap y las dos columnas salian con guion mientras el
                  neto si traia numero. */}
              {data.affiliates.map((a, i) => (
                <tr key={a.partner_id || i}>
                  <td style={TD}>
                    {a.name || '(sin nombre)'}
                    {esTraspaso(a.cls) && <Marca cls={a.cls} />}
                  </td>
                  <td style={NUM}>
                    {dinero(a.receivable)}
                    {/* Son los dias del documento MAS VIEJO, no el promedio.
                        Antes salia como "240d" sin etiqueta, al lado de una
                        tabla que dice "Dias prom.": dos cosas distintas con el
                        mismo nombre. */}
                    {Number.isFinite(Number(a.receivable_oldest)) && Number(a.receivable) > 0 && (
                      <span style={{ fontSize: 11, color: 'var(--text-3)' }}
                            title="Días del documento más viejo, no el promedio.">
                        {' '}· más viejo {miles(a.receivable_oldest)}d
                      </span>
                    )}
                  </td>
                  <td style={NUM}>
                    {dinero(a.payable)}
                    {Number.isFinite(Number(a.payable_oldest)) && Number(a.payable) > 0 && (
                      <span style={{ fontSize: 11, color: 'var(--text-3)' }}
                            title="Días del documento más viejo, no el promedio.">
                        {' '}· más viejo {miles(a.payable_oldest)}d
                      </span>
                    )}
                  </td>
                  <td style={{ ...NUM, fontWeight: 600,
                               color: Number(a.net) < 0 ? 'var(--red)' : 'var(--text)' }}>
                    {dinero(a.net)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 14 }}>
        Calculado {data.generated_at ? new Date(data.generated_at).toLocaleString() : '—'} ·
        compañía {data.company_id} de Odoo · los datos se guardan en caché cinco minutos, usa
        Recargar desde Odoo para tirarlo.
      </p>
    </>
  );
}
